import { render, staticRenderFns } from "./AdminEditUserSidebar.vue?vue&type=template&id=f95595e4&"
import script from "./AdminEditUserSidebar.vue?vue&type=script&lang=ts&"
export * from "./AdminEditUserSidebar.vue?vue&type=script&lang=ts&"
import style0 from "./AdminEditUserSidebar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports